import state from './system.state'
import mutations from './system.mutations'
import actions from './system.actions'

export default {
  state,
  mutations,
  actions
}
